import { render, staticRenderFns } from "./Basisdaten.vue?vue&type=template&id=7cb5f632&scoped=true"
import script from "./Basisdaten.vue?vue&type=script&lang=js"
export * from "./Basisdaten.vue?vue&type=script&lang=js"
import style0 from "./Basisdaten.vue?vue&type=style&index=0&id=7cb5f632&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cb5f632",
  null
  
)

export default component.exports